import { useMutation } from '@tanstack/react-query';
import { createToken } from '../../api/setupServices';
import type { ICCTokenFormValues } from '../../components/iccToken/ICCTokenForm';
import { useErrorContext } from '../../errorHandler/context/ErrorContext';
import { type ApiError, AppError } from '../../errorHandler/errors';

export type ICCTokenProps = {
  createTokenUrl: string;
  setToken: (token: string) => void;
};

const useICCTokenMutation = ({ setToken, createTokenUrl }: ICCTokenProps) => {
  const { emitError } = useErrorContext();

  return useMutation({
    mutationFn: (values: ICCTokenFormValues) => {
      return createToken(
        {
          enterpriseId: values.integrationId,
          installationTokenExpirationInMinutes: 60,
        },
        createTokenUrl,
      );
    },
    onSuccess: (clientCreateResponse) => {
      setToken(clientCreateResponse?.clientMetadata?.installationTokenValue);
    },
    onError: (e: ApiError) => {
      emitError(new AppError(e));
    },
  });
};

export default useICCTokenMutation;
